import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';

export const getAdminDocuments = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  params: Api.IAdminMessagesGridParams,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;

      headers.append('sortField', params.sortField);
      headers.append('sortDir', params.sortDir);
      headers.append('page', String(params.page));
      headers.append('pageSize', String(params.pageSize));

      const currentAdminDocumentEndpoint = `${url}/documentmanagement/getalldocumentdetails`;

      fetch(currentAdminDocumentEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((adminDocumentsResult: Common.IResult<Array<any>>) => {
          if (adminDocumentsResult && adminDocumentsResult.success) {
            adminDocumentsResult.data.map((row: any) => {
              row.idExt = `DOC-${row.id}`;
              row.statusExt = row.status;
              if (row.status === 'Ready') row.statusExt = 'Ready to publish';
              if (row.updatedDate === null && row.updatedBy === null) {
                row.updatedBy = row.createdBy;
              }
            });
          }
          success(adminDocumentsResult);
        });
    })
    .catch((e: any) => {
      error('getAdminDocuments');
    });
};

export const createDocument = async (
  account: AccountInfo,
  document: any,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };
  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();

      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var bodyFormData = new FormData();
      bodyFormData.append('file', document.file);
      bodyFormData.append('format', document.format);
      bodyFormData.append('title', document.title);
      bodyFormData.append('type', document.type);
      bodyFormData.append('audience', document.audience);
      bodyFormData.append('notifyByEmail', document.notifyByEmail);
      bodyFormData.append('notifyByAlert', document.notifyByAlert);
      bodyFormData.append('startDate', document.startDate);
      bodyFormData.append('endDate', document.endDate);
      bodyFormData.append('status', document.status);
      bodyFormData.append('bucket', 'document-store');

      if (document.references !== null) {
        document.references.map((reference: any) => {
          bodyFormData.append('references', reference);
        });
      }

      var options: any = {
        method: 'POST',
        headers: headers,
        body: bodyFormData,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;

      var createAdminDocumentEndpoint = `${url}/documentmanagement/createdocument`;

      fetch(createAdminDocumentEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((createDocumentsResult: Common.IResult<Array<boolean>>) => {
          success(createDocumentsResult);
        });
    })
    .catch((e: any) => {
      error('createdocument');
    });
};

export const updateDocument = async (
  account: AccountInfo,
  document: any,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };
  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();

      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var bodyFormData = new FormData();
      bodyFormData.append('file', document.file);
      bodyFormData.append('format', document.format);
      bodyFormData.append('title', document.title);
      bodyFormData.append('type', document.type);
      bodyFormData.append('audience', document.audience);
      bodyFormData.append('notifyByEmail', document.notifyByEmail);
      bodyFormData.append('notifyByAlert', document.notifyByAlert);
      bodyFormData.append('startDate', document.startDate);
      bodyFormData.append('endDate', document.endDate);
      bodyFormData.append('status', document.status);
      bodyFormData.append('bucket', document.bucket);
      bodyFormData.append('storageKey', document.storageKey);
      bodyFormData.append('id', document.id);

      if (document.references !== null) {
        document.references.map((reference: any) => {
          bodyFormData.append('references', reference);
        });
      }

      var options: any = {
        method: 'PUT',
        headers: headers,
        body: bodyFormData,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;

      var updateAdminDocumentEndpoint = `${url}/documentmanagement/updatedocument`;

      fetch(updateAdminDocumentEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((updateDocumentsResult: Common.IResult<Array<boolean>>) => {
          success(updateDocumentsResult);
        });
    })
    .catch((e: any) => {
      error('updatedocument');
    });
};

export const publishDocument = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  id: number,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'POST',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const publishBulkDocumentEndpoint = `${url}/documentmanagement/publishdocument/${id}`;

      fetch(publishBulkDocumentEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((publishDocumentsResult: Common.IResult<Array<boolean>>) => {
          success(publishDocumentsResult);
        });
    })
    .catch((e: any) => {
      error('publishdocument');
    });
};

export const deleteDocument = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  id: number,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'DELETE',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;

      const deleteAdminDocumentEndpoint = `${url}/documentmanagement/deletedocument?id=${id}`;

      fetch(deleteAdminDocumentEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((deleteDocumentResult: Common.IResult<Array<boolean>>) => {
          success(deleteDocumentResult);
        });
    })
    .catch((e: any) => {
      error('deleteDocument');
    });
};

export const getDocumentTypes = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const getDocumentTypes = `${url}/documentmanagement/documenttype`;

      fetch(getDocumentTypes, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((documentTypeResult: Common.IResult<Array<Api.IDocumentType>>) => {
          success(documentTypeResult);
        });
    })
    .catch((e: any) => {
      error('getDocumentTypes');
    });
};

export const getBulkUploadDirectories = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const directoriesUrl = `${url}/documentmanagement/bulkuploaddirectories`;

      fetch(directoriesUrl, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((documentTypeResult: Common.IResult<Array<string>>) => {
          success(documentTypeResult);
        });
    })
    .catch((e: any) => {
      error('getBulkUploadDirectories');
    });
};

export const createBulkUpload = async (
  account: AccountInfo,
  document: any,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };
  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      headers.append('parentDirectory', document.parentDirectory);

      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var bodyFormData = new FormData();
      bodyFormData.append('orchestrationFile', document.orchestrationFile);

      var options: any = {
        method: 'POST',
        headers: headers,
        body: bodyFormData,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;

      var endpoint = `${url}/documentmanagement/bulkdocumentupload`;

      fetch(endpoint, options)
        .then(response => {
          if (response.status === 201 || response.status === 400) {
            return response.json();
          }
        })
        .then((result: Api.IBulkUploadResponse) => {
          success(result);
        });
    })
    .catch((e: any) => {
      error('bulkdocumentupload');
    });
};
